
export default {
  acceptTypes: ".jpg, .jpeg, .png, .bmp, .JPG, .JPEG, .BMP, .PNG, .webp, .WEBP",
}



// WEBPACK FOOTER //
// ./src/js/picture-tool.js